class ProtectedComponent extends HTMLElement {
  constructor() {
    super();
    this.currentUser = null;
  }
  connectedCallback() {
    this.connectAuthListeners();
  }

  disconnectedCallback() {
    this.disconnectAuthListeners();
  }


  setCurrentUser(user) {
    this.currentUser = user;
    if (this.currentUser) {
      // Use loadIfVisible if available, otherwise call load directly
      if (typeof this.loadIfVisible === 'function') {
        this.loadIfVisible();
      } else {
        this.load();
      }
      return;
    }
    this.clear();
  }

  isAuthenticated() {
    return this.currentUser !== null;
  }

  load() {
    // abstract method to load content

  }

  clear() {
    // abstract method to clear content when logged out

  }

  handleAuthSuccess(e) {
    this.setCurrentUser(e.detail?.user || {});
  }

  handleUserLoggedOut() {
    this.setCurrentUser(null);
  }

  handleAuthStatusLoaded(e) {
    if (e.detail.authenticated) {
      this.setCurrentUser(e.detail.user || {});
    } else {
      this.setCurrentUser(null);
    }
  }

  connectAuthListeners() {
    // Listen for authentication events
    document.addEventListener('auth-success', this.handleAuthSuccess.bind(this));
    document.addEventListener('user-logged-out', this.handleUserLoggedOut.bind(this));
    document.addEventListener('auth-status-loaded', this.handleAuthStatusLoaded.bind(this));
  }

  disconnectAuthListeners() {
    // Remove event listeners when component is removed
    document.removeEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
    document.removeEventListener('auth-success', this.handleAuthSuccess);
    document.removeEventListener('user-logged-out', this.handleUserLoggedOut);
  }

}
export default ProtectedComponent;
